// @flow

import * as browserEnv from '../browserEnv'
import * as fengjr from './fengjr'
import * as ydd from './ydd'
import * as weixinApp from './weixin'
import { setCookie } from '../cookie'
import { fetchVisitor } from 'projects/fengjr/visitor'

type ShareInfo = {
  title: string,
  imgUrl: string,
  desc: string,
  link: string,
  failure?: () => void,
  success?: () => void
};

function callApp (method: string, ...args: Array<any>) {
  let fn
  if (
    browserEnv.isInFjApp() ||
    browserEnv.isInZxApp() ||
    browserEnv.isInXqkdApp() ||
    browserEnv.isInLcsApp()
  ) {
    fn = fengjr[method]
  } else if (browserEnv.isInYddApp()) {
    fn = ydd[method]
  } else if (browserEnv.isInWeixinApp()) {
    fn = weixinApp[method]
  }
  if (typeof fn === 'function') {
    fn(...args)
  }
}

type NavBarConfig = {
  text: string,
  image: string,
  clickCallback: Function
};

export function initPage () {
  callApp('initPage')
}

export function setPageTitle (title: string) {
  callApp('setPageTitle', title)
}

export function setPageDefaultTitle (title: string) {
  callApp('setPageDefaultTitle', title)
}

export function setNavigationBarRightButton (navBarConfig: NavBarConfig) {
  callApp('setNavigationBarRightButton', navBarConfig)
}

export function closeToRoot () {
  callApp('closeToRoot')
}

export function close () {
  callApp('close')
}

export function hiddenShareButton () {
  callApp('hiddenShareButton')
}

export function showShareButton (shareInfo: ShareInfo) {
  callApp('showShareButton', shareInfo)
}

export function share (shareInfo: ShareInfo) {
  callApp('share', shareInfo)
}

export function openThirdPartyApps (linkUrl: string) {
  callApp('openThirdPartyApps', linkUrl)
}

export function nativeCopy (copyText: string) {
  callApp('nativeCopy', copyText)
}

export function toPageRouter (path: string, replace?: boolean) {
  if (path === '/appLogin') {
    callApp('login', function () {
      callApp('getUser', function (user: { token: string }) {
        setCookie('token', user.token)
        fetchVisitor().then(function () {
          window.location.reload()
        })
      })
    })
  } else {
    callApp('toPageRouter', path, replace)
  }
}

export function login (success: Function, cancel?: Function) {
  callApp('login', success, cancel)
}

export function getUser (callback: Function) {
  callApp('getUser', callback)
}

export function closeLeftGesture () {
  callApp('closeLeftGesture')
}

export function hideBackIcon () {
  callApp('hideBackIcon')
}

export function showBackIcon () {
  callApp('showBackIcon')
}

export function sharePageToWeixin () {
  callApp('sharePageToWeixin')
}

export function historyBack () {
  callApp('historyBack')
}

type Message = {
  type: string,
  value: any,
};

export function message (msg:Message) {
  callApp('message',msg)
}


// WEBPACK FOOTER //
// ./src/frame/core/app/all.js